import React from 'react';
import { useIntl } from '@leagueplatform/locales';
import { usePageViewAnalytics } from '@leagueplatform/analytics';
import { useDocumentTitle } from '@leagueplatform/web-common';
import { Masonry } from '@leagueplatform/masonry';
import { MASONRY } from 'common/constants';
import { StackLayout } from '@leagueplatform/genesis-core';
import { CONTENT_MAX_WIDTH } from '@leagueplatform/web-common-components';
import { ConnectionErrorPage } from 'pages/errors/connection-error/connection-error.page';

export const HomePage = () => {
  usePageViewAnalytics({ screen_name: 'Home' });
  const { formatMessage } = useIntl();
  useDocumentTitle(formatMessage({ id: 'STR_HOME' }));

  return (
    <StackLayout
      orientation="vertical"
      verticalAlignment="center"
      horizontalAlignment="stretch"
      css={{
        marginX: 'auto',
        padding: '$none $two',
        maxWidth: CONTENT_MAX_WIDTH,
        '@mobile': {
          padding: '$none $one',
        },
      }}
    >
      <Masonry
        rootNodeId={MASONRY.ROOT_NODE_ID_HOME_PAGE}
        rootErrorFallback={ConnectionErrorPage}
      />
    </StackLayout>
  );
};
